exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-rank-list[data-v-87f55a2a]{width:100%}.yxtbiz-rank-list .yxtbiz-rank-list__empty[data-v-87f55a2a]{display:flex;justify-content:center;align-items:center}\n", ""]);

